module.exports = __webpack_public_path__ + "img/produktbroschuren_fr.6286ba4a.png";